export default __webpack_public_path__ + "static/media/critical_update.212c9810.svg";